module.exports = __webpack_public_path__ + "static/media/export-icon.675517f1.svg";